//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mgDialog from '~/components/custom/mg-dialog.vue';

export default {
  components: {
    mgDialog,
  },
  props: {
    badgeData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isShowDialog: true,
      currentBadge: null
    }
  },
  mounted() {
    this.computeBadge();
  },
  methods: {
    handleClose() {
      this.isShowDialog = false;
    },
    computeBadge() {
       const {badges, level} = this.badgeData;
       this.currentBadge = badges[level - 1];
    },
    goBadge() {
      window.open(`${window.location.origin}/files/account?tab=badge`, '_blank');
    }
  }
};
